/* tslint:disable */

declare var Object: any;
export interface SFAttSummaryInterface {
  "id"?: number;
}

export class SFAttSummary implements SFAttSummaryInterface {
  "id": number;
  constructor(data?: SFAttSummaryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SFAttSummary`.
   */
  public static getModelName() {
    return "SFAttSummary";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SFAttSummary for dynamic purposes.
  **/
  public static factory(data: SFAttSummaryInterface): SFAttSummary{
    return new SFAttSummary(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SFAttSummary',
      plural: 'SFAttSummaries',
      path: 'SFAttSummaries',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SFAttSummary.ts